import { Address } from 'types/address';

export type AddressErrors = Partial<
  Record<'zip_code' | 'street' | 'street_number' | 'neighborhood' | 'city' | 'state', string>
>;

export const emptyAddress: Address = {
  id: 0,
  zip_code: '',
  street: '',
  street_number: '',
  complement: '',
  neighborhood: '',
  city: '',
  state: '',
};

const FIELDS: (keyof Address)[] = [
  'zip_code',
  'street',
  'street_number',
  'complement',
  'neighborhood',
  'city',
  'state',
];

export function isAddressFilled(address: Address | null): boolean {
  return !!address && FIELDS.some(field => String(address[field] ?? '').trim() !== '');
}

// CEPs que a consulta (ViaCEP) disse não existir. Fica aqui para as telas de cadastro, que só chamam
// validateAddress, bloquearem o salvamento sem cada uma guardar esse estado.
const unknownZipCodes = new Set<string>();

export function markZipCodeUnknown(zipCode: string) {
  unknownZipCodes.add(zipCode.replace(/\D/g, ''));
}

// Endereço vazio é válido (paciente sem endereço); preenchido exige CEP e os campos que a API obriga.
export function validateAddress(address: Address | null): AddressErrors {
  if (!address || !isAddressFilled(address)) return {};

  const zipDigits = address.zip_code.replace(/\D/g, '');

  if (!zipDigits) return { zip_code: 'Informe o CEP para salvar o endereço' };
  if (zipDigits.length !== 8) return { zip_code: 'CEP incompleto. Informe os 8 números' };
  if (unknownZipCodes.has(zipDigits)) return { zip_code: 'CEP não encontrado. Confira os números.' };

  const errors: AddressErrors = {};
  if (!address.street.trim()) errors.street = 'Informe a rua';
  if (!address.street_number.trim()) errors.street_number = 'Informe o número ou marque sem número';
  if (!address.neighborhood.trim()) errors.neighborhood = 'Informe o bairro';
  if (!address.city.trim()) errors.city = 'Informe a cidade';
  if (!address.state.trim()) errors.state = 'Informe a UF';

  return errors;
}
